import api from '@/config/api'
import type { ApiResponse } from '@/shared/types/api'
import type { Matiere, CreateMatiereRequest, UpdateMatiereRequest } from '@/shared/types/admin'

export const matieresApi = {
  getAll: () =>
    api.get<ApiResponse<Matiere[]>>('/api/matieres').then((r) => r.data.data),

  getById: (id: number) =>
    api.get<ApiResponse<Matiere>>(`/api/matieres/${id}`).then((r) => r.data.data),

  getActives: () =>
    api.get<ApiResponse<Matiere[]>>('/api/matieres/actives').then((r) => r.data.data),

  create: (data: CreateMatiereRequest) =>
    api.post<ApiResponse<Matiere>>('/api/matieres', data).then((r) => r.data.data),

  update: (id: number, data: UpdateMatiereRequest) =>
    api.put<ApiResponse<Matiere>>(`/api/matieres/${id}`, data).then((r) => r.data.data),

  delete: (id: number) =>
    api.delete(`/api/matieres/${id}`),
}
